type WebStorage = {
  getItem: (key: string) => Promise<string | null>;
  setItem: (key: string, value: string) => Promise<void>;
  removeItem: (key: string) => Promise<void>;
};

type ExpiringPayload = {
  value: string;
  timestamp: number;
};

export function createExpiringWebStorage(baseStorage: WebStorage, ttlMs: number): WebStorage {
  const effectiveTtlMs = ttlMs > 0 ? ttlMs : 3600000;

  return {
    getItem: async (key: string) => {
      const raw = await baseStorage.getItem(key);
      if (raw == null) {
        return null;
      }

      try {
        const parsed = JSON.parse(raw) as ExpiringPayload;
        if (
          typeof parsed.value !== 'string' ||
          typeof parsed.timestamp !== 'number' ||
          Date.now() - parsed.timestamp > effectiveTtlMs
        ) {
          await baseStorage.removeItem(key);
          return null;
        }
        return parsed.value;
      } catch {
        await baseStorage.removeItem(key);
        return null;
      }
    },
    setItem: async (key: string, value: string) => {
      const payload: ExpiringPayload = { value, timestamp: Date.now() };
      await baseStorage.setItem(key, JSON.stringify(payload));
    },
    removeItem: (key: string) => baseStorage.removeItem(key),
  };
}
